const animateTime = {
    fast: 300,
    standard: 400,
    slow: 500,
    slower: 600,
    textIn: 1000,
};
const animeConfig = {
    autoplay: false,
    easing: 'easeInOutCubic',
};
const animeEasing = {
    easingTextIn: 'cubicBezier(.34,.615,.4,.985)',
};
const aerialMap = {
    aspectRatio: 0.625, // image ratio: 10: 16;
};
const vimeoSettings = {
    autoplay: true,
    autopause: false,
    background: true,
    byline: false,
    controls: false,
    dnt: true,
    loop: true,
    muted: true,
};

export default {
    animateTime,
    animeConfig,
    animeEasing,
    aerialMap,
    vimeoSettings,
};
